import { action, computed } from 'mobx'
import { type Bundle } from './Bundle'
import {
  type BundleDialogs,
  type BundleSelection,
} from './WorkspaceBundleViewModel'

export interface BundleItemViewModelOptions {
  bundle: Bundle
  selection: BundleSelection
  dialogs: BundleDialogs
}

/**
 * A bundle card in the bundle manager.
 */
export class BundleItemViewModel {
  constructor(private readonly _options: BundleItemViewModelOptions) {}

  /**
   * The bundle on the card.
   */
  get bundle() {
    return this._options.bundle
  }

  @computed
  get isSelected() {
    return this._options.selection.isSelected(this.bundle.id)
  }

  @action.bound
  setSelected(checked: boolean) {
    this._options.selection.toggleBundle(checked, this.bundle.id)
  }

  @action.bound
  archive() {
    void this._options.dialogs.archiveBundleVm.prompt(this.bundle)
  }

  @action.bound
  unarchive() {
    void this._options.dialogs.unarchiveBundleVm.prompt(this.bundle)
  }

  @action.bound
  duplicate() {
    this._options.dialogs.duplicateBundleVm.openBundle(this.bundle)
  }

  @action.bound
  edit() {
    this._options.dialogs.editBundleVm.openBundle(this.bundle)
  }
}
